import { Fragment } from 'react';

import { Typography } from '../Typography';

import {
  ColumnStyled,
  ContainerStyled,
  RowStyled,
  RowContainerStyled,
} from './TableMobile.styles';
import { TableMobileBaseRow, TableMobileProps } from './types';

export const TableMobile = <Row extends TableMobileBaseRow>({
  columns,
  rows,
  separatedRows = false,
  labelsColumnMinWidth,
}: TableMobileProps<Row>) => {
  const RowContainer = separatedRows ? RowContainerStyled : Fragment;
  return (
    <ContainerStyled separatedRows={separatedRows}>
      {rows.map((row, dataIndex) => {
        const isLastVisualRow = separatedRows || dataIndex === rows.length - 1;
        return (
          <RowContainer
            // eslint-disable-next-line react/no-array-index-key
            key={dataIndex}
            labelsColumnMinWidth={
              typeof labelsColumnMinWidth === 'number'
                ? `${labelsColumnMinWidth}px`
                : labelsColumnMinWidth
            }
          >
            {columns.map((column, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Fragment key={index}>
                {/* column */}
                <ColumnStyled
                  isLastColumn={index === columns.length - 1}
                  isLastRow={isLastVisualRow}
                  separatedRows={separatedRows}
                >
                  <Typography
                    className="tableMobile-column-title"
                    variant="bodyMedium"
                  >
                    {column.title}
                  </Typography>
                </ColumnStyled>
                {/* field */}
                <RowStyled
                  isLastColumn={index === columns.length - 1}
                  isLastRow={isLastVisualRow}
                  separatedRows={separatedRows}
                >
                  {column.renderCell ? (
                    column.renderCell(row, column.field)
                  ) : (
                    <Typography>{row[column.field]}</Typography>
                  )}
                </RowStyled>
              </Fragment>
            ))}
          </RowContainer>
        );
      })}
    </ContainerStyled>
  );
};
